import React, { useState } from "react";
import AiFeatureToolPrep from "../../shared/Popup/AiFeatureToolPrep";
import AiPresetCards from "../../shared/Popup/AiPresetCards";
import { presetTip } from "../../shared/Popup/presetTip";

const MODES = [
  {
    id: "auto",
    label: "Auto",
    sub: "Main faces",
    tip: presetTip('Auto — "Main faces"', [
      "Detects primary faces in the photo",
      "Fastest when faces are clear and front-facing",
    ]),
  },
  {
    id: "guided",
    label: "Guided",
    sub: "Describe swap",
    tip: presetTip('Guided — "Describe swap"', [
      "Tell the AI which face to change",
      "Useful with multiple people in frame",
    ]),
  },
];

const BLENDS = [
  {
    id: "natural",
    label: "Natural",
    sub: "Recommended",
    tip: presetTip('Natural — "Recommended"', [
      "Matches lighting and skin tone carefully",
      "Best everyday blend",
    ]),
  },
  {
    id: "strong",
    label: "Strong",
    sub: "Full swap",
    tip: presetTip('Strong — "Full swap"', [
      "More complete face replacement",
      "Use when features must change clearly",
    ]),
  },
];

/**
 * AI Tools → AI Face Swap prep.
 */
const FaceSwapToolPrep = (props) => {
  const [modeId, setModeId] = useState("auto");
  const [blendId, setBlendId] = useState("natural");
  const [prompt, setPrompt] = useState("");

  return (
    <AiFeatureToolPrep
      {...props}
      toolKey="ai_face_swap"
      title="AI Face Swap"
      aka="Face Swapper"
      bio="Swap faces between photos with a natural blend."
      emptyPreviewLabel="Upload an image to preview face swap"
      loadingLabel="Swapping face…"
      emptyFooterHint="Upload a photo, describe the swap if needed, then generate."
      renderControls={({ busy, leftPanelRef }) => (
        <>
          <div className="aftp-section">
            <p className="aftp-label">Mode</p>
            <AiPresetCards
              presets={MODES}
              selectedId={modeId}
              columns={2}
              ariaLabel="Face swap mode"
              boundaryRef={leftPanelRef}
              disabled={busy}
              onSelect={(id) => {
                setModeId(id);
              }}
            />
          </div>
          <div className="aftp-section">
            <p className="aftp-label">Blend</p>
            <AiPresetCards
              presets={BLENDS}
              selectedId={blendId}
              columns={2}
              ariaLabel="Face blend"
              boundaryRef={leftPanelRef}
              disabled={busy}
              onSelect={(id) => {
                setBlendId(id);
              }}
            />
          </div>
          <div className="aftp-section">
            <label className="aftp-label" htmlFor="aftp-fs-prompt">
              Swap details
              {modeId !== "guided" ? (
                <span className="aftp-optional"> (optional)</span>
              ) : null}
            </label>
            <textarea
              id="aftp-fs-prompt"
              className="aftp-input"
              rows={3}
              value={prompt}
              onChange={(e) => {
                setPrompt(e.target.value);
              }}
              placeholder="e.g. swap the person on the left with the reference face"
              disabled={busy}
            />
          </div>
        </>
      )}
    />
  );
};

export default FaceSwapToolPrep;
